/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Impact.css";

class Impact extends Component {
  render() {
    const vm = this.props.vm;
    const m = vm.m;
    const im = vm.im;
    return (
      <div className="Marketplace-Impact Marketplace-animIn">
        <div className="Marketplace-Impact-hero">
          <div className="Marketplace-Impact-heroRow">
            <div className="Marketplace-Impact-heroCopy">
              <div className="Marketplace-Impact-eyebrow">{im.eyebrow}</div>
              <h2 className="Marketplace-Impact-headline">{im.headline}</h2>
              <p className="Marketplace-Impact-sub">{im.sub}</p>
              <div className="Marketplace-Impact-periods">
                {vm.impactPeriods.map((p) => (
                  <div
                    className="Marketplace-Impact-period"
                    style={{ background: p.bg, color: p.fg }}
                    onClick={p.pick}
                    key={p.id}
                  >
                    {p.label}
                  </div>
                ))}
              </div>
            </div>
            <div className="Marketplace-Impact-totalCard">
              <div className="Marketplace-Impact-totalLabel">{m.impactTotalGiven}</div>
              <div className="Marketplace-Impact-totalValue">{im.totalLabel}</div>
              <div className="Marketplace-Impact-totalLines">
                <div>{im.months}</div>
                <div>{im.orgCount}</div>
                <div>{im.avgLabel}</div>
              </div>
              <div className="Marketplace-Impact-totalBtns">
                <div className="Marketplace-Impact-btnGhost">{m.impactDownloadPdf}</div>
                <div className="Marketplace-Impact-btnPrimary">{m.impactShare}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="Marketplace-Impact-section">
          <div className="Marketplace-Impact-sectionLabel">{m.impactWhereItWent}</div>
          <div className="Marketplace-Impact-splitBar">
            {im.causeSplit.map((c) => (
              <div
                className="Marketplace-Impact-splitSeg"
                style={{ background: c.color, width: c.w }}
                key={c.id}
              >
                {c.label}
              </div>
            ))}
          </div>
          <div className="Marketplace-Impact-legend">
            {im.causeSplit.map((c) => (
              <div className="Marketplace-Impact-legendItem" key={c.id}>
                <span className="Marketplace-Impact-legendDot" style={{ background: c.color }} />
                <span className="Marketplace-Impact-legendPct">{c.pct}</span>
                <span className="Marketplace-Impact-legendLabel">
                  {c.label} · {c.amount}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="Marketplace-Impact-section">
          <div className="Marketplace-Impact-sectionLabel">{m.impactWhatItBought}</div>
          <div className="Marketplace-Impact-outcomeGrid">
            {im.outcomes.map((o) => (
              <div className="Marketplace-Impact-outcome" key={o.id}>
                <div className="Marketplace-Impact-outcomeTop">
                  <div
                    className="Marketplace-Impact-outcomeMono"
                    style={{ background: o.tint, color: o.color }}
                  >
                    {o.logo ? (
                      <img src={o.logo} alt={o.name} className="Marketplace-Impact-outcomeMonoImg" />
                    ) : (
                      o.mono
                    )}
                  </div>
                  <div className="Marketplace-Impact-outcomeInfo">
                    <div className="Marketplace-Impact-outcomeName">{o.name}</div>
                  </div>
                </div>
                <div className="Marketplace-Impact-outcomeBody">
                  <div className="Marketplace-Impact-outcomeAmount" style={{ color: o.onWhite }}>
                    {o.amountLabel}
                  </div>
                  <div className="Marketplace-Impact-outcomeLines">
                    {o.lines.map((l) => (
                      <div className="Marketplace-Impact-outcomeLine" key={l.id}>
                        <span
                          className="Marketplace-Impact-outcomeTick"
                          style={{ background: o.tint, color: o.color }}
                        >
                          ✓
                        </span>
                        <span>{l.text}</span>
                      </div>
                    ))}
                  </div>
                  <div className="Marketplace-Impact-outcomeLink">{m.impactReadUpdate}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {vm.isBusiness && (
          <div className="Marketplace-Impact-section">
            <div className="Marketplace-Impact-sectionLabel">{m.impactCustomersSaw}</div>
            <div className="Marketplace-Impact-bizGrid">
              <div className="Marketplace-Impact-bizTile">
                <div className="Marketplace-Impact-bizValue">{im.customers}</div>
                <div className="Marketplace-Impact-bizLabel">{m.impactPurchases}</div>
              </div>
              <div className="Marketplace-Impact-bizTile">
                <div className="Marketplace-Impact-bizValue">{im.receiptsShown}</div>
                <div className="Marketplace-Impact-bizLabel">{m.impactReceiptsShown}</div>
              </div>
              <div className="Marketplace-Impact-bizTile">
                <div className="Marketplace-Impact-bizValue">{im.staffPicks}</div>
                <div className="Marketplace-Impact-bizLabel">{m.impactStaffPicks}</div>
              </div>
              <div className="Marketplace-Impact-bizTile Marketplace-Impact-bizTile--rank">
                <div className="Marketplace-Impact-bizRank">{m.impactRank}</div>
                <div className="Marketplace-Impact-bizShare">{m.impactShareThis}</div>
              </div>
            </div>
          </div>
        )}

        <div className="Marketplace-Impact-lower">
          <div>
            <div className="Marketplace-Impact-sectionLabel">{m.impactMilestones}</div>
            <div className="Marketplace-Impact-milestones">
              {im.milestones.map((ms) => (
                <div className="Marketplace-Impact-milestone" key={ms.id}>
                  <span className="Marketplace-Impact-milestoneWhen">{ms.when}</span>
                  <span className="Marketplace-Impact-milestoneText">{ms.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="Marketplace-Impact-receipts">
            <div className="Marketplace-Impact-receiptsHead">
              <span className="Marketplace-Impact-receiptsTitle">{m.impactReceipts}</span>
              <span className="Marketplace-Impact-receiptsNote">{m.impactS88Eligible}</span>
            </div>
            {im.ledger.map((l) => (
              <div className="Marketplace-Impact-receiptRow" key={l.ref}>
                <div className="Marketplace-Impact-receiptInfo">
                  <div className="Marketplace-Impact-receiptDate">{l.date}</div>
                  <div className="Marketplace-Impact-receiptRef">{l.ref}</div>
                </div>
                <span className="Marketplace-Impact-receiptAmount">{l.amountLabel}</span>
                <span className="Marketplace-Impact-receiptPdf">PDF</span>
              </div>
            ))}
            <div className="Marketplace-Impact-receiptTotal">
              <span>{m.impactTotalForPeriod}</span>
              <span>{im.receiptTotal}</span>
            </div>
          </div>
        </div>

        <div className="Marketplace-Impact-ctaWrap">
          <div className="Marketplace-Impact-cta">
            <div className="Marketplace-Impact-ctaCopy">
              <div className="Marketplace-Impact-ctaTitle">{m.impactCtaTitle}</div>
              <div className="Marketplace-Impact-ctaBody">{m.impactCtaBody}</div>
            </div>
            <div className="Marketplace-Impact-ctaBtns">
              <div className="Marketplace-Impact-ctaGhost" onClick={vm.goAllocate}>
                {m.impactCtaAdjust}
              </div>
              <div className="Marketplace-Impact-ctaSolid" onClick={vm.goBrowse}>
                {m.impactCtaDiscover}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Impact.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default Impact;
